import type { DB } from '@/types/common';

export enum PaymentRequestStatus {
	CREATED = 'CREATED',
	ACKNOWLEDGED = 'ACKNOWLEDGED',
	REJECTED = 'REJECTED',
	ACCEPTED = 'ACCEPTED',
}

export enum PaymentRequestAction {
	ACKNOWLEDGED = 'acknowledged',
	ACCEPTED = 'accepted',
	PARTIALLY_ACCEPTED = 'partiallyAccepted',
	REJECTED = 'rejected',
	EDIT = 'edit',
}

export enum PaymentRequestCreatedOrigin {
	AGENCY = 'agency',
	WORKER = 'worker',
}

export interface PaymentRequestHistory {
	status: PaymentRequestStatus;
	timestamp: number;
	userId: string;
	comment?: string;
}

export interface PaymentRequestUser {
	id: string;
	firstname: string;
	lastname: string;
	picture?: string | null;
}

export interface PopulatedPaymentRequest extends PaymentRequestDB {
	users: PaymentRequestUser[];
	worker: PaymentRequestUser;
	creator: Pick<PaymentRequestUser, 'firstname' | 'lastname'>;
}

export interface PaymentRequestCreateBody {
	origin: PaymentRequestCreatedOrigin;
	requestedAmount: number;
	agencyId?: string;
	workerId: string;
}

export interface PaymentRequestUpdateBody {
	status: PaymentRequestStatus;
	comment?: string;
	acceptedAmount?: number;
}

export interface PaymentRequestActionSubmit {
	status: PaymentRequestStatus;
	comment?: string;
	acceptedAmount?: number;
}

export interface PaymentRequest {
	creatorId: string;
	origin: PaymentRequestCreatedOrigin;
	workerId: string;
	agencyId: string;
	status: PaymentRequestStatus;
	history: PaymentRequestHistory[];
	requestedAmount: number | 0; // 0 is for max
	acceptedAmount?: number;
	comment?: string;
}

export interface PaymentRequestDB extends PaymentRequest, DB {}

export const StatusFilterInProgress = [
	PaymentRequestStatus.CREATED,
	PaymentRequestStatus.ACKNOWLEDGED,
];
export const StatusFilterArchived = [
	PaymentRequestStatus.ACCEPTED,
	PaymentRequestStatus.REJECTED,
];

export type StatusFilter = PaymentRequestStatus[];
